// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCAbuMNk7g4nV_HBQTrn_8GsBqHbFpkFqg",
  authDomain: "nara-e491e.firebaseapp.com",
  projectId: "nara-e491e",
  storageBucket: "nara-e491e.firebasestorage.app",
  messagingSenderId: "725126190772",
  appId: "1:725126190772:web:76b41423ae01c6a723a9e1",
  measurementId: "G-1HG0GQ6BHW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();